module.exports = __webpack_public_path__ + "static/media/restauDuCoeur.26030bd7.png";